var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check-circle-alt (3) 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Domain",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle-alt-(3)-2",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle-alt-(3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon16/core/close-big",
    transform: "translate(2.000000, 2.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.51929112,5.76929112 L11.0192911,5.76929112 L11.0192911,6.51929112 L6.51929112,6.51929112 L6.51929112,11.0192911 L5.76929112,11.0192911 L5.76929112,6.51929112 L1.26929112,6.51929112 L1.26929112,5.76929112 L5.76929112,5.76929112 L5.76929112,1.26929112 L6.51929112,1.26929112 L6.51929112,5.76929112 Z",
    id: "Combined-Shape",
    transform: "translate(6.144291, 6.144291) rotate(45.000000) translate(-6.144291, -6.144291) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCross);
export default __webpack_public_path__ + "static/media/circle-cross.27ef6c1b4804808f5ac71a01141ca0c2.svg";
export { ForwardRef as ReactComponent };